import { ref } from "vue";
import { useState } from "@erp/shared/composables";
import { useRouter } from "@erp/shared/composables/useRouter";
function createDialogState(confirmIdKey) {
    const [confirmId] = useState(null);
    const isOpen = ref(false);
    const setOpen = {
        get: () => isOpen.value,
        set: (value) => (isOpen.value = value),
    };
    return {
        isOpen,
        setOpen,
        [confirmIdKey]: confirmId,
    };
}
export function useDocumentDialog() {
    const router = useRouter();
    const estimateDialog = createDialogState("estimateConfirmId");
    const obtainDialog = createDialogState("obtainConfirmId");
    const orderDialog = createDialogState("orderConfirmId");
    const purchaseDialog = createDialogState("purchaseConfirmId");
    const inboundDialog = createDialogState("inboundConfirmId");
    const outboundDialog = createDialogState("outboundConfirmId");
    const isCommercial = ref(true);
    function openDocument(documentType, documentId, metadata) {
        if (!documentId)
            return;
        if (documentType === "project")
            return;
        if (metadata?.isCommercial !== undefined) {
            isCommercial.value = Boolean(metadata.isCommercial);
        }
        else {
            isCommercial.value = true;
        }
        switch (documentType) {
            case "estimate":
                estimateDialog.estimateConfirmId.value = documentId;
                estimateDialog.setOpen.set(true);
                break;
            case "obtain":
                obtainDialog.obtainConfirmId.value = documentId;
                obtainDialog.setOpen.set(true);
                break;
            case "approval_document":
                router.push({
                    path: "/approval-document",
                    query: { id: String(documentId) },
                });
                break;
            case "order":
                orderDialog.orderConfirmId.value = documentId;
                orderDialog.setOpen.set(true);
                break;
            case "purchase":
                purchaseDialog.purchaseConfirmId.value = documentId;
                purchaseDialog.setOpen.set(true);
                break;
            case "inbound":
                inboundDialog.inboundConfirmId.value = documentId;
                inboundDialog.setOpen.set(true);
                break;
            case "outbound":
                outboundDialog.outboundConfirmId.value = documentId;
                outboundDialog.setOpen.set(true);
                break;
        }
    }
    return {
        estimateDialog,
        obtainDialog,
        orderDialog,
        purchaseDialog,
        inboundDialog,
        outboundDialog,
        isCommercial,
        openDocument,
    };
}
